import {UserId} from '@legit.health/ui';
import {useTranslation} from 'react-i18next';
import {useSuspensePatient} from '@/practitioner/hooks/patient/usePatient';
import {FullScreenModalTitle} from '@/shared/components/ui/Modal';

export default function ModalTitle({patientId}: {patientId: UserId}) {
  const patient = useSuspensePatient(patientId);
  const {t} = useTranslation(['shared/common']);

  const title = t('shared/common:diagnosticReport.form.newCase', {
    patientFullname: patient.fullname
  });

  return <FullScreenModalTitle>{title}</FullScreenModalTitle>;
}
